import { toValue } from "vue";
import type { MaybeRefOrGetter } from "vue";

export function useSVGTextWidthCache(
  svgElement: MaybeRefOrGetter<SVGSVGElement | undefined>
) {
  const textWidthCache = new Map<string, number>();

  function measureTextWidthCached(text: string, fontSize = 12) {
    if (!text || !fontSize) return 0;

    const cacheKey = fontSize + text;
    if (textWidthCache.has(cacheKey)) {
      return textWidthCache.get(cacheKey) || 0;
    }

    const svg = toValue(svgElement);
    if (!svg) return 0;
    const t = document.createElementNS("http://www.w3.org/2000/svg", "text");
    t.textContent = text;
    t.setAttribute("font-size", `${fontSize}`);
    svg.appendChild(t);
    const textLength = t.getComputedTextLength();
    t.remove();

    textWidthCache.set(cacheKey, textLength);

    return textLength;
  }

  return { measureTextWidthCached };
}
